// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"B9-z"};